import React from 'react'
import { BentoGridContainer } from './BentoGrid/BentoGrid'
import { DynamicImageDiff } from './DynamicImageDiff/DynamicImageDiff'
import { useWindowWidth } from '@react-hook/window-size'
import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import { CardCategorySlider } from 'src/home_page/components/CardCategorySlider/CardCategorySlider'
import {
  BentoCardFragment,
  CardTypeSectionFragment,
  ImageDiffFragment,
} from 'src/strapi/queries'
import { SectionBentoContainer } from './SectionBentoContainer'

type CardTypeSectionProps = {
  isMobile?: boolean
  activeImageIndex: number
  setActiveImageIndex: (id: number) => void
  images: ImageDiffFragment[]
  cardSection: CardTypeSectionFragment
}

export const CardTypeSection: React.FC<CardTypeSectionProps> = ({
  isMobile,
  activeImageIndex,
  setActiveImageIndex,
  images,
  cardSection,
}) => {
  const windowWidth = useWindowWidth()

  const { gridArea, childrenGridArea, blobs } = cardSection

  const isBento = (
    c: BentoCardFragment | null | undefined,
  ): c is BentoCardFragment => c != null

  if (!cardSection.cards) return <></>

  const safeCards = cardSection.cards.filter(isBento)

  const sectionType = cardSection.sectionType

  return (
    <>
      <Flex
        flexDirection="column"
        width="100%"
        height="100%"
        inset={{
          bottom: 'x4',
        }}
      >
        <Flex width="100%" justifyContent="center" alignItems="center">
          <Text
            inset={{
              top: '32px',
              bottom: 'x4',
            }}
            type="title"
            weight="semiBold"
            content={cardSection.gridTitle ?? ''}
            alignment="center"
          />
        </Flex>
        <BentoGridContainer
          isComponentRight={cardSection?.isComponentRight ?? false}
          blobs={{
            option: blobs?.option ?? 3,
            width: blobs?.width ?? '80%',
            height: 'auto',
            position: {
              bottom: '0px',
            },
            glassBlur: blobs?.glassBlur ?? 50,
          }}
          isFlexOverride={isMobile}
          gridRowOverride={cardSection.gridRowOverride ?? undefined}
          gridColumnOverride={cardSection.gridColumnOverride ?? undefined}
          maxHeight="auto"
          cards={safeCards}
          isMobile={isMobile}
          gridTexts={{
            title: cardSection.gridSubtitle ?? '',
            description: cardSection.gridDescription ?? '',
            gridArea: {
              colStart: gridArea?.colStart ?? '3',
              colEnd: gridArea?.colEnd ?? '6',
              rowStart: gridArea?.rowStart ?? '1',
              rowEnd: gridArea?.rowEnd ?? '4',
            },
          }}
          activeBentoCallback={setActiveImageIndex}
          childrenGridArea={{
            colStart: childrenGridArea?.colStart ?? '1',
            colEnd: childrenGridArea?.colEnd ?? '3',
            rowStart: childrenGridArea?.rowStart ?? '1',
            rowEnd: childrenGridArea?.rowEnd ?? '6',
          }}
        >
          <Flex
            justifyContent="center"
            alignItems="center"
            height="100%"
            width="100%"
          >
            {sectionType === 'image_slider' ? (
              <CardCategorySlider />
            ) : sectionType === 'image_diff' ? (
              <Flex
                justifyContent="center"
                alignItems="center"
                style={{
                  backgroundColor: '#ffffff99',
                  borderRadius: '1.25rem',
                  backdropFilter: 'blur(75px)',
                }}
                boxShadow="light"
                borderRadius="default"
                width={
                  windowWidth >= 520 && windowWidth <= 605
                    ? '70%'
                    : windowWidth >= 606 && windowWidth <= 800
                    ? '60%'
                    : windowWidth >= 801 && windowWidth <= 1180
                    ? '55%'
                    : '100%'
                }
                minWidth={isMobile ? undefined : '400px'}
                inset={'x4'}
              >
                <DynamicImageDiff
                  images={images}
                  activeImageIndex={activeImageIndex}
                />
              </Flex>
            ) : sectionType === 'static_image' ? (
              <SectionBentoContainer
                isMobile={isMobile}
                imageUrl={cardSection.bentoImage?.imageUrl.url ?? ''}
              />
            ) : (
              <></>
            )}
          </Flex>
        </BentoGridContainer>
      </Flex>
    </>
  )
}
